import * as React from 'react';
import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { PurchaseTypeSelectionBoxesView } from '@grandvisionhq/fun-products';
import { useProductDetailContext } from '../../../Context/ProductDetailContext.js';
import { useSolutionsEcommContext } from '../../context/SolutionsEcommContext.js';

/**
 * @deprecated
 */ const SolutionsPurchaseTypeSelectionBoxes = ({ className  })=>{
    const { activeVariant  } = useProductDetailContext();
    const { actions , state  } = useSolutionsEcommContext();
    const { purchaseType  } = state.configurations;
    const isAvailableForSubscription = CommerceToolsApi.isSolutions(activeVariant) && activeVariant.isAvailableForSubscription;
    const handleSelection = React.useCallback((key)=>actions.updatePurchaseType(key)
    , [
        actions
    ]);
    if (!isAvailableForSubscription || !activeVariant.purchaseTypePrices) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(PurchaseTypeSelectionBoxesView, {
        className: className,
        selectedPurchaseType: purchaseType,
        subscriptionTypeAllowed: isAvailableForSubscription,
        purchaseTypePrices: activeVariant.purchaseTypePrices,
        onSelection: handleSelection
    });
};

export { SolutionsPurchaseTypeSelectionBoxes };
//# sourceMappingURL=SolutionsPurchaseTypeSelectionBoxes.js.map
